import React, { useState, useEffect } from 'react';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getApiHeader } from 'utlis/commonfunctions';
import Loader from 'layouts/nbn/components/loader';

const SERVER_URL = process.env.REACT_APP_API_URL;

const MyDailyWorkPlanList = () => {

  const navigate = useNavigate();
  const [reviewers, setReviewers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Handle data fetching based on selected week
  const handleWeekChange = async (e) => {
    setLoading(true);
    const headers = await getApiHeader();

    try {
      const response = await axios.post(`${SERVER_URL}work-plan/get-my-daily-work-list`, {}, {
        headers: headers
      });

      if (response.data && response.data.data && Array.isArray(response.data.data.daily_work_list)) {
        const sortedData = response.data.data.daily_work_list.sort((a, b) => new Date(b.date) - new Date(a.date));
        setReviewers(sortedData);
      } else {
        setReviewers([]);
      }

    } catch (error) {
      console.error("Error fetching work plan data:", error);
    } finally {
      setLoading(false);
    }
  };


  // Update the pagination variables when reviewers change
  useEffect(() => {
    if (reviewers.length === 0) {
      setCurrentPage(0); // Set currentPage to 0 if there's no data
    } else if (currentPage === 0) {
      setCurrentPage(1); // Set currentPage to 1 if there's data
    }
  }, [reviewers]);

  // Pagination logic
  const indexOfLastReviewer = currentPage * itemsPerPage;
  const indexOfFirstReviewer = indexOfLastReviewer - itemsPerPage;
  const currentReviewers = reviewers.slice(indexOfFirstReviewer, indexOfLastReviewer);
  const totalPages = Math.ceil(reviewers.length / itemsPerPage);

  // Navigate to the detail view
  const handleViewDetails = (workPlanId, startDate) => {
    navigate('/my_daily_work_plan_edit', { state: { workPlanId, startDate } });
    
  };

  useEffect(() => {
    handleWeekChange({ target: { value: JSON.stringify({ start: '', end: '' }) } });
  }, []);


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className="container workplanform p-3">
        {/* Reviewer List */}
        <Typography variant="subtitle1" className="mt-3"><h4>My Daily Work Updates </h4></Typography>
        {/* <Typography variant="body2" color="textSecondary" gutterBottom>
          These details are for viewing and editing rejected retailer plan details.
        </Typography> */}
        {loading ? (
          <div className="text-center">
            <Loader />  {/* Replace with a loading spinner component */}
          </div>
        ) : (
        <div className="table-responsive mt-3">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Sl No</th>
                <th>Date</th>
                <th>Status</th>
                <th>Verified By</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentReviewers.length > 0 ? currentReviewers.map((reviewer, index) => (
                <tr key={reviewer.retailer_id}>
                  <td>{indexOfFirstReviewer + index + 1}</td>
                  <td>
                  {new Date(reviewer.date).getFullYear()}-
                  {('0' + (new Date(reviewer.date).getMonth() + 1)).slice(-2)}-
                  {('0' + new Date(reviewer.date).getDate()).slice(-2)}, 
                  {new Date(reviewer.date).toLocaleDateString('en-US', { weekday: 'long' }).replace(/^/, ' ')}
                </td>

                  <td>
                    {reviewer.status === 1 ? 'Approved' :
                      reviewer.status === 2 ? 'Rejected' :
                        'Pending'}
                  </td>
                  <td>
                    {reviewer.verified_by === 'admin' ? reviewer.admin_user : 
                     reviewer.verified_by === 'manager' ? reviewer.manager_name : 'Not Verified'}
                    ({reviewer.verified_by})
                  </td>
                  <td>
                    {reviewer.status === 2 && (
                      <button
                        className="btn btn-danger btn-sm ms-2"
                        style={{ backgroundColor: '#e20e75' }}
                        onClick={() => handleViewDetails(reviewer.daily_work_id, reviewer.date)}
                      >
                        View Work Details
                      </button>
                    )}
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="6" className="text-center">No work plans found for the selected week</td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Pagination Controls */}
          {totalPages > 0 && (
            <div className="pagination-controls text-center">
              <button
                className="btn btn-light btn-sm"
                disabled={currentPage <= 1}
                onClick={() => handlePageChange(currentPage - 1)} // Go to the previous page
              >
                Previous
              </button>
              <span className="mx-2">{currentPage} of {totalPages}</span>
              <button
                className="btn btn-light btn-sm"
                disabled={currentPage >= totalPages}
                onClick={() => handlePageChange(currentPage + 1)} // Go to the next page
              >
                Next
              </button>
            </div>
          )}

        </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default MyDailyWorkPlanList;
